import React from 'react';

import WithStatefulTooltip from '@r1-frontend/ui-react/experimental/tooltip/WithStatefulTooltip';
import WithStatelessTooltip from '@r1-frontend/ui-react/experimental/tooltip/WithStatelessTooltip';

import { TTooltipProps } from './types';

/**
 * Добавляет оборачиваемому компоненту возможность отображения
 * всплывающей подсказки
 *
 * @notes
 * Компонент автоматически определяет stateful/stateless поведение
 * в зависимости от использования параметра `isShown`
 */
const WithTooltip = (props: TTooltipProps) => {
    const { isShown } = props;

    return isShown !== undefined
        ? <WithStatelessTooltip {...props} />
        : <WithStatefulTooltip {...props} />;
};

export default WithTooltip;
